import { Box, FlexBox } from '../../box';
import { styled } from '../../styled';
import { Typography } from '../../typography';
export const Root = styled(FlexBox)(({ theme }) => ({
    flexDirection: 'column',
    width: '100%',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
}));
export const Group = styled(FlexBox)(({ theme }) => ({
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%'
}));
export const PaddedBlock = styled(FlexBox)(({ theme }) => ({
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
}));
export const GroupSeparator = styled(FlexBox)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(0.5),
    width: '100%'
}));
export const SeparatorLine = styled(Box)(({ theme }) => ({
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.divider
}));
export const SeparatorLineStart = styled(SeparatorLine)(({ theme }) => ({
    flex: '0 0 auto',
    width: theme.spacing(1.5)
}));
export const RowList = styled(FlexBox)({
    flexDirection: 'column'
});
export const FilterRow = styled(FlexBox)(({ theme }) => ({
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flexWrap: 'nowrap',
    width: 'fit-content',
    '& :has(> .MuiFormHelperText-root)': {
        position: 'relative',
        paddingBottom: theme.spacing(3),
        '& > .MuiFormHelperText-root': {
            position: 'absolute',
            top: theme.spacing(3.75),
            left: 0,
            whiteSpace: 'nowrap'
        }
    }
}));
export const ValueGroup = styled(FlexBox)(({ theme }) => ({
    alignItems: 'flex-start',
    gap: theme.spacing(1)
}));
export const Comparator = styled(Typography)(({ theme }) => ({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(3.75),
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.palette.components?.['simple-select']?.label,
    lineHeight: theme.spacing(2.75),
    letterSpacing: '0.46px',
    color: theme.palette.text.disabled,
    padding: theme.spacing(0.5, 0.75)
}));
